import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../utils/pickIf';

const getAddToCartButtonStyles = (
  theme,
  listView,
  detailsMode,
  isRecurringMaterials,
) => {
  let addToCartWidth = 96;
  if (detailsMode) {
    addToCartWidth = 200;
  }
  if (isRecurringMaterials) {
    addToCartWidth = 105;
  }
  if (listView) {
    return {
      width: 130,
      height: 36,
      padding: theme.spacing(1),
      fontSize: 14,
      [theme.breakpoints.down('lg')]: {
        width: addToCartWidth,
        height: pickIf(detailsMode, 44, 34),
      },
      [theme.breakpoints.down('md')]: {
        width: pickIf(detailsMode, 140, '100%'),
        height: 32,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          width: addToCartWidth,
          height: pickIf(detailsMode, 44, 34),
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          width: pickIf(detailsMode, 140, '100%'),
          height: 32,
        }),
      },
    };
  }
  return {
    width: pickIf(detailsMode, 130, '50%'),
    maxWidth: pickIf(detailsMode, 'unset', 130),
    height: 36,
    padding: theme.spacing(1),
    fontSize: 14,
    [theme.breakpoints.down('lg')]: {
      minWidth: pickIf(detailsMode, 200, 96),
      height: pickIf(detailsMode, 44, 34),
      fontSize: detailsMode && 16,
    },
    [theme.breakpoints.down('md')]: {
      width: pickIf(detailsMode, 140, 124),
      minWidth: pickIf(detailsMode, 140, 'unset'),
      maxWidth: pickIf(detailsMode, 'unset', 124),
      height: 32,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        minWidth: pickIf(detailsMode, 200, 96),
        height: pickIf(detailsMode, 44, 34),
        fontSize: detailsMode && 16,
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        width: pickIf(detailsMode, 140, 124),
        minWidth: pickIf(detailsMode, 140, 'unset'),
        maxWidth: pickIf(detailsMode, 'unset', 124),
        height: 32,
      }),
    },
  };
};

const getCountButton = (listView, theme, detailsMode) => {
  if (listView) {
    return {
      width: 130,
      height: 36,
      [theme.breakpoints.down('lg')]: {
        width: pickIf(detailsMode, 200, 96),
        height: pickIf(detailsMode, 44, 34),
      },
      [theme.breakpoints.down('md')]: {
        width: pickIf(detailsMode, 140, 96),
        height: pickIf(detailsMode, 44, 34),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          width: pickIf(detailsMode, 200, 96),
          height: pickIf(detailsMode, 44, 34),
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          width: pickIf(detailsMode, 140, 96),
          height: pickIf(detailsMode, 44, 34),
        }),
      },
    };
  }
  return {
    width: pickIf(detailsMode, 130, '50%'),
    maxWidth: 130,
    height: 36,
    [theme.breakpoints.down('lg')]: {
      minWidth: pickIf(detailsMode, 200, 96),
      height: pickIf(detailsMode, 44, 34),
    },
    [theme.breakpoints.down('md')]: {
      minWidth: pickIf(detailsMode, 140, 96),
      height: pickIf(detailsMode, 44, 34),
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        minWidth: pickIf(detailsMode, 200, 96),
        height: pickIf(detailsMode, 44, 34),
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        minWidth: pickIf(detailsMode, 140, 96),
        height: pickIf(detailsMode, 44, 34),
      }),
    },
  };
};

export const useStyles = makeStyles()(
  (theme, { detailsMode, listView, isRecurringMaterials } = {}) => {
    return {
      container: {
        position: 'relative',
        display: 'flex',
        flexDirection: pickIf(detailsMode || !listView, 'row', 'column'),
        alignItems: 'center',
        gap: 10,
        padding: 0,
        [theme.breakpoints.down('lg')]: {
          flexDirection: 'row',
        },
        [theme.breakpoints.down('md')]: {
          marginRight: 0,
          justifyContent: pickIf(!detailsMode && !listView, 'center', 'unset'),
          width: '100%',
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...(theme.isMobileDevice && {
            flexDirection: 'row',
          }),
        },
        [theme.breakpoints.downLandscape('md')]: {
          ...(theme.isMobileDevice && {
            marginRight: 0,
            justifyContent: pickIf(
              !detailsMode && !listView,
              'center',
              'unset',
            ),
            width: '100%',
          }),
        },
      },
      countButton: getCountButton(listView, theme, detailsMode),
      qtyButtonLabel: {
        height: pickIf(detailsMode, 'initial', 36),
        width: detailsMode && 130,
        [theme.breakpoints.down('lg')]: {
          height: 'initial',
          width: detailsMode && 'auto',
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...(theme.isMobileDevice && {
            height: 'initial',
            width: detailsMode && 'auto',
          }),
        },
      },
      addToCartButton: getAddToCartButtonStyles(
        theme,
        listView,
        detailsMode,
        isRecurringMaterials,
      ),
    };
  },
);
